import { render, staticRenderFns } from "./new-form.vue?vue&type=template&id=0b0662b5&"
import script from "./new-form.vue?vue&type=script&lang=js&"
export * from "./new-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports